import {
  CLEAR_VAULT_REQUEST_LIST,
  CLEAR_VAULT_REQUEST_LIST_ERROR,
  GET_VAULT_REQUEST_LIST_REQUESTED,
} from './actionTypes';

export const getVaultRequestList = (vaultRequestSearchCriteria) => ({
  type: GET_VAULT_REQUEST_LIST_REQUESTED,
  payload: {
    vaultRequestSearchCriteria,
  },
});

export const clearVaultRequestListError = () => ({
  type: CLEAR_VAULT_REQUEST_LIST_ERROR,
});

export const clearVaultRequestList = () => ({
  type: CLEAR_VAULT_REQUEST_LIST,
});
